interface ProductRecommendedCellDelegate
{
    recommendedProductDidSelect(cell:ProductRecommendedCell, product:Product):void;
}

class ProductRecommendedCell extends UITableViewCell
{
    delegate:ProductRecommendedCellDelegate = null;

    private nameTextField:MUITextField = null;
    private nameLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameTextField = MUIOutlet(this, "name-tf", "MUITextField");
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");

        this.setupProductTextField(this.nameTextField, this, this.productDidSelect);

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _product:Product = null;
    set item( item:Product ){
        if (item == null) return;

        this._product = item;
        if (this.nameLabel) this.nameLabel.text = item.name;
    }

    private searchTimer:MIOTimer = null;
    private searchString:string = null;
    protected setupProductTextField(textField:MUITextField, target:any, completion:any){
        if (textField == null) return;        
        textField.setOnChangeText(this, function(control:MUITextField, value:string){
            this.searchString = value;
            if (this.searchTimer != null) this.searchTimer.invalidate();
            this.searchTimer = MIOTimer.scheduledTimerWithTimeInterval(500, false, this, function(timer:MIOTimer){
                this.searchProductTimerFired(textField, this.searchString, target, completion);
                this.searchTimer = null;
            });
        });

        textField.setOnDidEndEditing(this, function(control:MUITextField, value:string){
            AppHelper.sharedInstance().dismissSelectStockProductViewController();
        });
    }

    protected searchProductTimerFired(textField:MUITextField, value:string, target, completion){        
        AppHelper.sharedInstance().showSelectProductViewControllerFromView(textField, value, null, target, completion, this, null);
    }

    protected productDidSelect(controller:SelectEntityViewController, product:Product, supplierProduct?:SupplierProduct){
        this._product = product;
        this.nameTextField.text = product.name;
        this.delegate?.recommendedProductDidSelect(this, product);
    }

}